module.exports = __webpack_public_path__ + "static/img/ga.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ga.png
// module id = YnlU
// module chunks = 1